import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BehaviorSubject} from '@node_modules/rxjs';
import {Schedule} from '@models/schedule';
import {Subject} from '@node_modules/rxjs/internal/Subject';
import * as moment from 'moment';
import {User} from '@models/user';
import {Program} from '@models/program';
import {ProgramScheduleComponent} from '@pages/layout/program/program-page/program-schedule/program-schedule.component';
import {StudentService} from '@services/student/student.service';
import {ProgramClassesComponent} from '@pages/layout/program/program-page/program-classes/program-classes.component';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {UpdateAuthUser} from '@store/auth/actions';
import {MatDialog} from '@node_modules/@angular/material';
import {Router} from '@node_modules/@angular/router';
import {ProgramService} from '@services/program/program.service';
import {Curriculum} from '@models/curriculum';
import {SetPrograms} from '@store/program/actions';
import {ViewCurriculumComponent} from '@pages/layout/program/program-page/program-curriculum/view-curriculum/view-curriculum.component';

@Component({
  selector: 'app-program-schedule-day',
  templateUrl: './program-schedule-day.component.html',
  styleUrls: ['./program-schedule-day.component.scss']
})
export class ProgramScheduleDayComponent implements OnInit {
  @Input() programSubject: BehaviorSubject<Program>;
  @Input() programsIdWithSubscriptionSubject:   BehaviorSubject<{program_id: number, subscription_id: number}>;
  @Input() userSubject: BehaviorSubject<User>;
  @Input() programs: Program[];
  @Input() schedulePrograms: Program[];
  @Input() onToday: Subject<any>;
  @Input() source = 'program';
  @Input() role = 'notAdmin';
  @Input() onLeft: Subject<any>;
  @Input() onRight: Subject<any>;
  @Input() initSchedule: Schedule;
  @Input() insertingSchedule: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  @Output() selectedDaySchedulesChange = new EventEmitter<any>();
  programsIdWithSubscription:  {program_id:number, subscription_id: number};
  classesByDates = {};
  currentDate = moment();
  monthsNumber: Subject<any> = new BehaviorSubject(this.getMonthNumber());
  moveStudentsCarousel: BehaviorSubject<string> = new BehaviorSubject(null);
  schedules:  BehaviorSubject<any> = new BehaviorSubject(null);
  students: User[];
  viewCirriculumDialog;
  program: Program;
  allPrograms = [];
  subscribes = [];
  selectedClassId;
  selectedMonth: number = moment().month() + 1;
  selectedDay: number = moment().date();
  currentYear = new Date().getFullYear();
  loading = true;
  lastEvent;
  reorganisedSchedule;
  confirmDialog;
  user: User;
  constructor(
      private studentService: StudentService,
      public dialog: MatDialog,
      private router: Router,
      private authStore: Store<AuthReducer.AuthState>,
      private programService: ProgramService,
  ) { }

  ngOnInit() {
    console.log(this);
    if (this.userSubject) {
      this.subscribes.push(this.userSubject.subscribe(
          resp => {
            // console.log(resp);
            this.user = resp;
            // this.onSelectedDay(this.lastEvent);
          }
      ));
    }
    if (this.programsIdWithSubscriptionSubject) {
      this.subscribes.push(this.programsIdWithSubscriptionSubject.subscribe(
          resp => {
            this.programsIdWithSubscription = resp;
          }
      ));
    }
    if (this.programSubject) {
      this.subscribes.push(this.programSubject.subscribe(
          resp => {
            if (resp && resp.classes) {
              this.program = resp;
              this.reorganisedSchedule = ProgramClassesComponent.reorganizeSchedule(this.program);
              this.insertingSchedule.next(this.reorganisedSchedule);
            }
          }
      ));
    }
    if (this.onToday) {
      this.subscribes.push(this.onToday.subscribe(
          (resp: any) => {
            // console.log(resp);
            if (resp) {
              this.currentDate = moment();
              this.monthsNumber.next({month: this.getMonthNumber(), year: this.getYear()});
              this.selectedClassId = null;
              this.students = [];
              this.selectedMonth = moment().month() + 1;
              this.selectedDay = moment().date();
              setTimeout(() => {
                this.insertingSchedule.next(this.reorganisedSchedule);
              }, 5);

            }
          }
      ));
    }
    if (this.onLeft) {
      this.subscribes.push(this.onLeft.subscribe(
          (resp: any) => {
            if (resp && resp === 'month') {
              // console.log(resp);
              this.currentDate.add(-1, 'month');
              // if (resp === 'month') {
              //   this.currentDate.add(-1, 'month');
              // }
              // if (resp === 'week') {
              //   this.currentDate.add(-1, 'week');
              // }
              this.monthsNumber.next({month: this.getMonthNumber(), year: this.getYear()});
              this.selectedClassId = null;
              this.students = [];
            }
          }
      ));
    }
    if (this.onRight) {
      this.subscribes.push(this.onRight.subscribe(
          (resp: any) => {
            // console.log(resp);
            if (resp && resp === 'month') {
              this.currentDate.add(1, 'month');
              // if (resp === 'month') {
              //   this.currentDate.add(1, 'month');
              // }
              // if (resp === 'week') {
              //   this.currentDate.add(1, 'week');
              // }
              this.monthsNumber.next({month: this.getMonthNumber(), year: this.getYear()});
              this.selectedClassId = null;
              this.students = [];
            }
          }
      ));
    }
    if (this.insertingSchedule) {
      this.insertingSchedule.subscribe(
          resp => {
            this.loading = !resp;
          }
      );
    }

    // this.setClassesByMonth();
    if (this.program) {
      this.reorganisedSchedule = ProgramClassesComponent.reorganizeSchedule(this.program);
      this.insertingSchedule.next(this.reorganisedSchedule);
    }
    this.onToday.next(true);

    if (this.role === 'admin') {
      this.programService.getAll()
          .subscribe(
              (resp: {data: any}) => {
                resp.data.map(program => {
                  this.programService.getProgram(program.id)
                      .subscribe(
                          (resp1: {data: Program}) => {
                            this.allPrograms.push(resp1.data);
                            if (this.lastEvent) {
                              this.onSelectedDay(this.lastEvent);
                            }
                          }
                      );
                });
              }
          );
    }
  }
  // setClassesByMonth() {
  //   new Array(this.currentDate.daysInMonth()).fill(1).map((day, i) => {
  //       const currentDay = this.currentDate.clone().startOf('month').add(i, 'days');
  //       this.classesByDates = ProgramScheduleComponent.getClassByDate(this.programs, currentDay, this.classesByDates, false, false, false);
  //   });
  //   // this.insertingSchedule.next(this.classesByDates);
  // }
  getMonthNumber() {
    return this.currentDate.month() + 1;
  }
  getYear() {
    return this.currentDate.year();
  }
  isGoing(schedule: Schedule) {
    const scheduleTimeStart = moment(schedule.start, 'HH:mm A').month(this.selectedMonth - 1).date(this.selectedDay);
    const scheduleTimeEnd = moment(schedule.end, 'HH:mm A').month(this.selectedMonth - 1).date(this.selectedDay);
    if (this.source === 'student') {
      scheduleTimeStart.add('-1', 'hours');
    }


    const condition1 = moment().isBetween(scheduleTimeStart, scheduleTimeEnd) || moment().isSame(scheduleTimeStart);
    let condition2 = true;
    // if (this.user && this.user.current_lesson && this.user.current_lesson.end) {
    //   let userSubscriptionId = null;
    //   this.user.subscriptions.map( item => {
    //     if (item.id === schedule.subscription_id) {
    //       userSubscriptionId = item.userSubscriptionId;
    //     }
    //   });
    //   if (this.user.current_lesson.user_subscription_id && this.user.current_lesson.user_subscription_id === userSubscriptionId) {
    //     const currentLessonEndMoment = moment(this.user.current_lesson.end, 'HH:mm A');
    //     condition2 = scheduleTimeStart.isSameOrAfter(currentLessonEndMoment.clone().add(10, 'minutes'));
    //   } else {
    //     this.authStore.dispatch(new UpdateAuthUser({current_lesson: null}));
    //   }
    //
    // }

    return condition1 && condition2;
  }
  onSelectedDay(event) {
    // const date = new Date().setHours(0, 0, 0, 0);
    // const date = moment().date(event.day).month(event.month - 1).year(this.currentYear).toDate();
    const programs = this.getSchedulePrograms();
    this.lastEvent = event;
    this.selectedDay = +event.day;
    this.selectedMonth = +event.month;
    this.selectedClassId = null;
    this.students = [];
    const selectedSchedules = event.schedules || [];
    selectedSchedules.map( item => {
      const dayFromCalendar = moment(item.start, 'HH:mm A').month(this.selectedMonth - 1).date(this.selectedDay).year(this.getYear());
      if (ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')] &&
          ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][item.id]) {
        item.lesson = ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][item.id];
      } else {
        programs.map(program => {
          const programId = program ? (program.id || program.program_id) : null;
          if (String(item.program_id) === String(programId)) {
            this.classesByDates = ProgramScheduleComponent.getClassByDate(program, [program], dayFromCalendar.toDate(), {}, false, moment(), 'MMM Do YY HH:mm A');
            if ( ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')] &&
              ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][item.id]
            ) {
              item.lesson = ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][item.id];
            }
          }
        });
      }
      if (this.programsIdWithSubscription && this.programsIdWithSubscription[item.program_id]) {
        item.subscription_id = this.programsIdWithSubscription[item.program_id];
      }
    });
    this.schedules.next(selectedSchedules);
    this.selectedDaySchedulesChange.emit({
      day: this.selectedDay,
      month: this.selectedMonth,
      year: this.getYear(),
      selectedDate: moment([this.getYear(), this.selectedMonth - 1, this.selectedDay]).toDate(),
      schedules: selectedSchedules
    });
    // this.schedules = event.schedules;
    // console.log(event.schedules);
  }
  onGetStudents(schedule) {
    console.log(schedule);
    if (this.source === 'program') {
      this.selectedClassId = schedule.id;
      this.studentService.getClassStudents(schedule.class_id).subscribe(
          (resp: { data: User[] }) => {
            this.students = resp.data;
          }
      );
    }
  }
  onOpenViewCurriculumModal(classc) {
    const programs = this.getSchedulePrograms();
    console.log(programs, classc);
    if (!classc || !classc.lesson) {
      return;
    }
    let curriculum, programActive;
    programs.map( program => {
      const curriculums = program && program.curriculum ? program.curriculum : [];
      curriculums.map( curr => {
        const lessons = curr.lessons || [];
        lessons.map( lesson => {
          if (lesson.id === classc.lesson.id) {
            curriculum = curr;
            programActive = program;
          }
        });
      });
    });
    if (curriculum) {
      console.log(programActive);
      ViewCurriculumComponent.source = 'student';
      ViewCurriculumComponent.onlyLesson = true;
      ViewCurriculumComponent.curriculum = curriculum;
      ViewCurriculumComponent.program = programActive;
      ViewCurriculumComponent.initClass = classc;
      ViewCurriculumComponent.initLesson = classc.lesson;
      ViewCurriculumComponent.fullContent = false;
      ViewCurriculumComponent.onlyDescription = false;
      this.viewCirriculumDialog = this.dialog.open(ViewCurriculumComponent, {
        panelClass: 'mkc-dashboard-lesson-dialog',
        backdropClass: 'mkc-dashboard-lesson-backdrop',
      });
      ViewCurriculumComponent.modalRef = this.viewCirriculumDialog;
      this.viewCirriculumDialog.afterClosed().subscribe(result => {
        this.viewCirriculumDialog.close();
      });
    }
  }

  private getSchedulePrograms(): Program[] {
    if (this.role === 'admin') {
      return this.allPrograms;
    }
    if (this.schedulePrograms && this.schedulePrograms.length) {
      return this.schedulePrograms;
    }
    return this.program ? [this.program] : [];
  }
}
